import React from 'react';

const DotsBackground = () => {
    return (
        <>

            <svg xmlns="http://www.w3.org/2000/svg" width="504" height="307" viewBox="0 0 504 307">
                <g>
                    <path d="M403,104A101,101,0,1,1,302,205,101,101,0,0,1,403,104Z" fill="#1c2284"/>
                    <circle cx="403" cy="205" r="57" fill="#e62d82"/>
                </g>
                <g>
                    <circle cx="153.5" cy="153.5" r="153.5" fill="#00aa96"/>
                    <circle cx="154" cy="153" r="112" fill="#1c2284"/>
                    <circle cx="154" cy="153" r="87" fill="#0096d7"/>
                </g>
            </svg>

            <svg xmlns="http://www.w3.org/2000/svg" width="448" height="448" viewBox="0 0 448 448">
                <g>
                    <circle cx="224" cy="224" r="224" fill="#1c2284"/>
                    <ellipse cx="224.5" cy="224" rx="169.5" ry="169" fill="#00aa96"/>
                </g>
            </svg>

        </>
    );
}

export default DotsBackground;
